import React from "react";
import { Row, Col } from "react-bootstrap";
import {
  LuBadgeDollarSign,
  LuCircleSlash,
  LuFiles,
  LuBadgeMinus,
} from "react-icons/lu";
import "./MedicalTourism6.css";

const transparencyData = [
  {
    icon:  "/assets/cost1.svg",
    title: "Transparent Pricing",
    desc: "Every quote itemized before you travel, in writing.",
  },
  {
    icon:  "/assets/cost2.svg",
    title: "No Hidden Charges",
    desc: "What's quoted is what's billed — no surprise line items.",
  },
  {
    icon:  "/assets/cost3.svg",
    title: "Negotiated Packages",
    desc: "Bulk hospital relationships pass savings directly to you.",
  },
  {
    icon:  "/assets/cost4.svg",
    title: "Avoid Unnecessary Costs",
    desc: "We flag procedures or stays that don't add clinical value.",
  },
];

const MedicalTourism6 = () => {
  return (
    <section className="costTransparency standard-padding">
      <h1 className="heading costTransparency-heading">
        Complete Cost Transparency
      </h1>

      <Row className="g-3">
        {transparencyData.map((item, index) => (
          <Col lg={6} md={6} xs={12} key={index}>
            <div className="costCard">
              <div className="costIcon">
                 <img src={item.icon} alt={item.title} />
              </div>

              <div className="costContent">
                <h4 className="costTitle">
                  {item.title}
                </h4>

                <p className="costDesc">
                  {item.desc}
                </p>
              </div>
            </div>
          </Col>
        ))}
      </Row>
    </section>
  );
};

export default MedicalTourism6;